<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" :label="$t('USER.Name')" v-model="name" v-validate="'required|alpha_spaces'" name="name" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input class="w-full mt-4" :label="$t('USER.Email')" v-model="email" disabled type="email" v-validate="'required|email'" name="email" />
        <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <div class="mt-4">
            <label class="text-sm">{{ $t('USER.Languages') }}</label>
            <v-select
            multiple
            label="name"
            v-model="user_selected_languages"
            :closeOnSelect="true"
            :options="langOptions"
            @input="setLanguages"
            v-validate="'required'"
            name="languages"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
             />
            <span class="text-danger text-sm"  v-show="errors.has('languages')">{{ errors.first('languages') }}</span>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">

        <div class="mt-4">
          <label class="vs-input--label">{{ $t('USER.role') }}</label>
          <v-select v-model="role_local" :clearable="false" label="name" :options="roleOptions" v-validate="'required'" name="role" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('role')">{{ errors.first('role') }}</span>
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Status</label>
          <v-select :disabled="hash === this.$store.state.auth.user.hash" v-model="status_local" :clearable="false" :options="statusOptions" v-validate="'required'" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
        </div>

        <div class="vs-component vs-con-input-label vs-input w-full mt-4 vs-input-primary">
          <label for="" class="vs-input--label">{{ $t('USER.mobile') }}</label>
          <div class="vs-con-input"><the-mask type="text" name="mobile" v-model="mobile" :mask="['+55 (##) ####-####', '+55 (##) #####-####']" class="vs-inputx vs-input--input normal hasValue" style="border: 1px solid rgba(0, 0, 0, 0.2);"/></div>
          <span class="text-danger text-sm"  v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
        </div>
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col md:w-1/2 w-full">
        <ul class="con-s w-full">
          <li>
            <label class="vs-input--label">Admin ?</label>
            <vs-switch v-model="isAdmin" class="mt-2" />
          </li>
          <li class="mt-4">
            <label class="vs-input--label">{{ $t('USER.externalUser') }}</label>
            <vs-switch v-model="isExternalUser" class="mt-2" />
          </li>
        </ul>
      </div>
    </div>

    <div class="vx-row" v-if="customFields.length > 0">

      <div class="vx-col md:w-1/2 w-full" v-for="(field, index) in customFields" :key="index">
        <div v-if="field.type === 'select'" class="mt-4">
          <label class="text-sm">{{ field.label }}</label>
          <v-select
            :options="field.options"
            label="label"
            :clearable="true"
            v-model="customFieldsModel[field.name]"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
        <div v-else-if="field.type === 'select_multiple'" class="mt-4">
          <label class="text-sm">{{ field.label }}</label>
          <v-select
            :options="field.options"
            label="label"
            multiple
            v-model="customFieldsModel[field.name]"
            :closeOnSelect="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">{{ $t('USER.EDIT.save_changes') }}</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.push('/users')">{{ $t('USER.EDIT.cancel') }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {
  performFetch,
  getUserCustomFields,
  validateUserCustomField,
  initUserCustomFieldModel,
  buildUserCustomDataForSave
} from '../../../helpers'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      hash: '',
      name: '',
      email: '',
      mobile: '',
      isAdmin: false,
      isExternalUser: false,
      role: {},
      status: 1,
      local_language: [],
      user_selected_languages: [],
      statusOptions: [
        { label: this.$t('USER.Ativo'),  value: 1 },
        { label: this.$t('USER.inactive'),  value: 2 }
      ],
      roleOptions: [],
      langOptions: [],
      allLanguageOptions: [],
      delegatorUrl: '',
      customFields: [],
      customFieldsModel: {},
    }
  },
  computed: {
    // status_local: {
    //   get () {
    //     return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
    //   },
    //   set (obj) {
    //     this.data_local.status = obj.value
    //   }
    // },
    status_local: {
      get () {
        return {
          label: this.status === 1 ? this.$t('USER.Ativo') : this.$t('USER.inactive'),
          value: this.status
        }
      },
      set (obj) {
        this.status = obj.value
      }
    },
    role_local: {
      get () {
        return {
          name: this.role.name,
          hash: this.role.hash
        }
      },
      set (obj) {
        this.role = obj
      }
    },
    validateForm () {
      return !this.errors.any()
    }
  },
  created () {
    this.$vs.loading({type: 'default'})
    setTimeout(async () => {
      this.getViewParameters()
        .then(() => {

          fetch(this.$store.state.auth.api_url, {
            method: 'POST', headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
              command: 'get_application_user_detail',
              parameters: {
                application_token: this.$store.state.auth.app_token,
                session_token: this.$store.state.auth.token,
                user_hash: this.$route.params.userHash
              }
            })
          })
            .then(async (response) => {
              if (response.status === 200) {
                await response.json().then(async (response) => {
                  this.$store.commit('userManagement/setUserEditName', response.user.name)
                  this.$store.commit('userManagement/setUserEditEmail', response.user.email)
                  this.$store.commit('userManagement/setUserEditMobile', response.user.mobile)
                  this.$store.commit('userManagement/setUserEditRole', response.user.role.hash)
                  this.$store.commit('userManagement/setUserEditRoleObject', response.user.role)
                  this.$store.commit('userManagement/setUserEditStatusId', response.user.status_id)
                  this.$store.commit('userManagement/setUserEditIsAdmin', response.user.is_admin)
                  this.$store.commit('userManagement/setUserEditExternalUser', response.user.external_user)
                  this.$store.commit('userManagement/setUserEditLanguages', response.user.languages)

                  this.hash = response.user.hash
                  this.name = response.user.name
                  this.email = response.user.email
                  this.mobile = response.user.mobile
                  this.role = response.user.role
                  this.status = response.user.status_id
                  this.isAdmin = response.user.is_admin
                  this.isExternalUser = !!response.user.external_user
                  this.delegatorUrl = response.delegator_url

                  await this.getCustomFields();

                  const user_languages = response.user.languages

                  this.user_selected_languages = user_languages

                  const user_languages_hash = []

                  user_languages.forEach((item, key) => {
                    user_languages_hash.push(item.hash)
                  })

                  this.langOptions = this.allLanguageOptions.filter(o => !user_languages_hash.includes(o.hash))

                  this.$vs.loading.close()
                // resolve(response.user)
                })
              } else if (response.status == 401) {
                setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                this.$store.dispatch('auth/signOut')
              }
            })
            .catch((error) => {
              console.log(error)

              this.$vs.notify({
                title: 'Operação não realizada!',
                text: error.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })

            })
        })
    }, 300)
  },
  methods: {
    async getCustomFields() {
      this.$vs.loading({
        type: 'default'
      })

      if(this.delegatorUrl) {
        try{
          const response = await getUserCustomFields(this.delegatorUrl, this.$store.state.auth.app_token, this.$store.state.auth.token, this.$route.params.userHash);
          if ('custom_fields' in response) {
            for (const field of response.custom_fields) {
              validateUserCustomField(field)

              this.customFields.push(field)
              this.$set(this.customFieldsModel, field.name, initUserCustomFieldModel(field))
            }
          }

        } catch(error) {
          console.error(`Erro ao capturar campos customizados: ${error}`)
        }
      }

      this.$vs.loading.close()
    },
    getViewParameters () {
      return new Promise(async (resolve, reject) => {
        await performFetch(this.$store.state.auth.api_url, {
            command: 'get_application_user_parameters',
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token
            }
          })
          .then(async (response) => {
            if (response.status === 200) {
              await response.json().then(async (response) => {

                this.allLanguageOptions = response.parameters.languages

                this.roleOptions = response.parameters.roles

                resolve(true)

              })
            } else if (response.status == 401) {
              setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
              this.$store.dispatch('auth/signOut')
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    setLanguages (e) {
      const selected_languages_hash = []

      e.forEach((item, key) => {
        selected_languages_hash.push(item.hash)
      })

      this.langOptions = this.allLanguageOptions.filter(o => !selected_languages_hash.includes(o.hash))
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      this.$vs.loading({ type: 'default' })

      fetch(this.$store.state.auth.api_url, {
        method: 'POST', headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          command: 'update_application_user',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            user: {
              hash: this.$route.params.userHash,
              name: this.name,
              mobile: this.mobile,
              languages: this.user_selected_languages,
              role: this.role,
              is_admin: this.isAdmin,
              external_user: this.isExternalUser,
              status_id: this.status,
              custom_data: buildUserCustomDataForSave(this.customFields, this.customFieldsModel)
            }
          },
        })
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {
              this.$vs.loading.close()
              this.$store.state.userManagement.userEditObject.changes = true
              this.$vs.notify({
                title: this.$t('USER.SuccessOperation'),
                text: this.$t('USER.UserUpdated'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

              this.$router.push('/users')
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('USER.operationNotPerformed'),
              text: this.$t('USER.UserUpdateError'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER.operationNotPerformed'),
            text: this.$t('USER.UserUpdateError'),
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'danger'
          })
        })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  }
}
</script>
